import { REPORT_REASONS } from '@qm/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';
import { Button, Field, Sheet, errorMessage, useToast } from './ui';

/** Жалоба на объявление, продавца или собеседника в чате (с приложенной перепиской). */
export function ReportSheet({
  open,
  onClose,
  target,
  title,
}: {
  open: boolean;
  onClose: () => void;
  target: { listingId: string } | { sellerId: string; conversationId?: string };
  title?: string;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const [reason, setReason] = useState<(typeof REPORT_REASONS)[number] | null>(null);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!reason) return;
    setBusy(true);
    try {
      await api('/reports', { method: 'POST', json: { ...target, reason, comment: comment.trim() || undefined } });
      toast(t('report.sent'), 'success');
      onClose();
      setReason(null);
      setComment('');
    } catch (e) {
      toast(errorMessage(t, e), 'error');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={title ?? ('sellerId' in target ? t('report.seller') : t('report.title'))}
      footer={
        <Button block loading={busy} disabled={!reason || (reason === 'other' && comment.trim().length < 5)} onClick={submit}>
          {t('report.submit')}
        </Button>
      }
    >
      <div className="radio-list" role="radiogroup">
        {REPORT_REASONS.map((r) => (
          <label key={r} className="check-row">
            <input type="radio" name="reason" checked={reason === r} onChange={() => setReason(r)} />
            <span>{t(`report.reasons.${r}`)}</span>
          </label>
        ))}
      </div>
      <Field label={t('report.comment')} hint={reason === 'other' ? t('report.commentRequired') : undefined}>
        <textarea className="input" rows={3} maxLength={1000} value={comment} onChange={(e) => setComment(e.target.value)} />
      </Field>
    </Sheet>
  );
}
